import { useEffect, useState } from 'react'
import { StateAccess, UseCanAccess } from './type'
import { useResourceDefinition } from 'react-admin'
import _find from 'lodash/find'
import config from '../config'
import { useUserPermission } from '../contexts/rbac-context'

const defaultAccessState = {
  isLoading: true,
  canAccess: false,
  permission: null,
}
export const useCanAccess: UseCanAccess = (props = {}) => {
  const { action = null, key = '' } = props
  const { name } = useResourceDefinition()
  const { currentPermissions, error } = useUserPermission()
  const [state, setState] = useState<StateAccess>(defaultAccessState)
  useEffect(() => {
    if (currentPermissions && name) {
      const feature = _find(currentPermissions, { key: key || config(`resources.keys.${name}`) })
      setState({
        isLoading: false,
        canAccess: feature ? (action ? feature[action] : false) : false,
        permission: feature || null,
      })
    }

    if (error)
      setState({
        isLoading: false,
        error,
      })
  }, [currentPermissions, setState, error, action, key, name])
  return state
}
